import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { FormService } from "../../../../@core/api/form.service";
import { Form } from "../../../../@core/data/form";
import { Router } from "@angular/router";
import { SnippetComponent } from "../../snippet/snippet.component";
import { ConfirmDialogComponent } from "../../../utils/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "ngx-form-row",
  templateUrl: "./form-row.component.html",
  styleUrls: ["./form-row.component.scss"],
})
export class FormRowComponent implements OnInit {
  @Input() form: Form;
  @Output() updateList = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private formService: FormService
  ) {}

  async ngOnInit() {}

  show(type) {
    switch (type) {
      case "edit":
        this.router.navigate(["home", "form", this.form.id]);
        break;
      case "code":
        this.dialogService
          .open(SnippetComponent, { context: { id: this.form.id } })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteForm();
            }
          });
        break;
        break;
      case "copy":
        this.copyForm();
        break;

      case "delete":
        this.dialogService
          .open(ConfirmDialogComponent, {
            context: { operation: "eliminare " + this.form.name },
          })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteForm();
            }
          });
        break;
    }
  }

  async copyForm() {
    let res = <any>await this.formService.duplicateForm(this.form.id);
    this.updateList.emit();
  }

  async showCode() {}

  async DeleteForm() {
    await this.formService.deleteForm(this.form.id);
    this.updateList.emit();
  }
}

function downloadURI(dataurl, filename) {
  const link = document.createElement("a");
  link.href = dataurl;
  link.download = filename;
  link.click();
}
